import "Ui/tabs";
import { initHandleMissingProductFormSubmit } from "./common/missingProductForm";

initHandleMissingProductFormSubmit();
